var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMigrar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 42,
    viewBox: "0 0 36 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6875 7.6875L28.6875 15.6875V20.766C27.2522 19.6587 25.453 19 23.5 19C18.8056 19 15 22.8056 15 27.5C15 30.288 16.3423 32.7625 18.4159 34.3125H10C9.29167 34.3125 8.66667 34.0625 8.125 33.5625C7.58333 33.0208 7.3125 32.3958 7.3125 31.6875L7.375 10.3125C7.375 9.60417 7.625 9 8.125 8.5C8.66667 7.95833 9.29167 7.6875 10 7.6875H20.6875ZM19.8337 9.27866L27 17L19.8336 17L19.8337 9.27866Z",
    fill: "#000E4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9375 25.2073L23.5411 25.2073L23.1143 24.7805L21.157 22.8232L20.9813 22.6475L20.8045 22.8222L18.8243 24.7795L18.3914 25.2073L19 25.2073L20.2237 25.2073L20.2237 32.3257L20.2237 32.5757L20.4737 32.5757L21.4638 32.5757L21.7138 32.5757L21.7138 32.3257L21.7138 25.2073L22.9375 25.2073Z",
    fill: "#000E4B",
    stroke: "#000E4B",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9375 30.1184L23.3339 30.1184L23.7607 30.5452L25.718 32.5024L25.8937 32.6782L26.0705 32.5035L28.0507 30.5462L28.4836 30.1184L27.875 30.1184L26.6513 30.1184L26.6513 23L26.6513 22.75L26.4013 22.75L25.4112 22.75L25.1612 22.75L25.1612 23L25.1612 30.1184L23.9375 30.1184Z",
    fill: "#000E4B",
    stroke: "#000E4B",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigrar);
export default __webpack_public_path__ + "static/media/migrar.607cf8907e2bf76fcef62a31b359f7b1.svg";
export { ForwardRef as ReactComponent };